import React from "react";
import { Navigate, Route, Routes } from "react-router";
import Error404PageService from "../../containers/Pages/Generic/Error404/Error404PageService";
import ServiceWorldCasePage from "../../containers/Pages/ServiceWorld/ServiceWorldCasePage";
import CalendlyPage from "../../containers/Pages/ServiceWorld/CalendlyPage";
import ApplicationFormPage from "../../containers/Pages/ApplicationForm/ApplicationFormPage";
import InquiryToCustomerPage from "../../containers/Pages/ServiceWorld/InquiryToCustomerPage";
import InquiryToCustomerAnsweredPage from "../../containers/Pages/ServiceWorld/InquiryToCustomerAnsweredPage";
import { useResolvedPath } from "react-router";
import useProductParams from "../../hooks/useProductParams";
import { getProductNameBy } from "../../services/productService";

export default function ServiceworldCase() {
  const { productName, productId } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName)

  return (
    <Routes>
      <Route path={"antrag/*"} element={<ApplicationFormPage />} />
      <Route path={"calendly/:responsibleParty/:appointmentType/*"} element={<CalendlyPage />} />
      <Route path={"dokumente-hochladen"} element={<Navigate to={`/servicewelt/nachrichten/neu?product=${productClassName}&productId=${productId}`} replace={true} />} />
      <Route path={"anfrage"} element={<Navigate to={useResolvedPath(".")} />} />
      <Route path={"anfrage/beantwortet"} element={<InquiryToCustomerAnsweredPage />} />
      <Route path={"anfrage/:inquiryId"} element={<InquiryToCustomerPage />} />
      <Route path={""} element={<ServiceWorldCasePage />} />
      <Route path={"*"} element={<Error404PageService />} />
    </Routes>
  );
}
